const approvalPolicies = 'ApprovalPolicies';
export const generateKeys = {
    list: (...args) => [approvalPolicies, 'list', ...args],
    byId: (id) => [approvalPolicies, id],
};
